const dateOnly = new Intl.DateTimeFormat("es-MX", { day: "numeric", month: "short", timeZone: "UTC" });
const fullDate = new Intl.DateTimeFormat("es-MX", { weekday: "long", day: "numeric", month: "long", year: "numeric" });

export function formatDate(value: string | null) {
  if (!value) return "Por confirmar";
  const date = new Date(value.length === 10 ? `${value}T12:00:00Z` : value);
  return dateOnly.format(date).replace(".", "");
}

export function formatLongDate(value: string | null) {
  if (!value) return "Fecha por confirmar";
  return fullDate.format(new Date(value)).replace(/^./, (letter) => letter.toUpperCase());
}

export function formatBytes(bytes: number) {
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

export function initials(name: string) {
  return name.split(/\s+/).map((part) => part[0]).filter(Boolean).slice(0, 2).join("").toUpperCase();
}
